import AbstractStore from './AbstractStore';
import * as _utils from '../Utils'

export default class ValueStore extends AbstractStore
{
    constructor(actions = [])
    {
        super(['add', 'update', 'remove', 'load', 'clear'].concat(actions));

        this.items = [];
    }
    load(items)
    {
        this.actions.load(items);
    }
    add(item)
    {
        this.actions.add(item);
    }
    update(item)
    {
        this.actions.update(item);
    }
    remove(item)
    {
        this.actions.remove(item);
    }
    clear()
    {
        this.actions.clear();
    }
    onLoad(items) {
        if (typeof items !== 'undefined' && null !== items) {
            for (let item of items) {
                if (null !== item) {
                    if (typeof item === 'object' && typeof item.id === 'undefined') {
                        item.id = _utils.uuid();
                    }
                    if(this.has(item)) {
                        this.items = _utils.updateItem(item, this.items, 'id');
                    } else {
                        this.items.push(item);
                    }
                }
            }
        }
        this.trigger(this.items);
    }
    onClear() {
        this.items = [];
        this.trigger(this.items);
    }
    onAdd(item) {
        if (typeof item === 'object' && typeof item.id === 'undefined') {
            item.id = _utils.uuid();
        }
        this.onUpdate(item);
    }
    onUpdate(item) {
        if(this.has(item)) {
            this.items = _utils.updateItem(item, this.items, 'id');
        } else {
            this.items.push(item);
        }
        this.trigger(this.items);
    }
    onRemove(item) {
        this.items = _utils.removeItem(item.id, this.items, 'id');
        this.trigger(this.items);
    }
    has(item) {
        return null !== _utils.getItem(item.id, this.items, 'id');
    }
    get(id)
    {
        return _utils.getItem(id, this.items, 'id');
    }
    length()
    {
        return this.items.length;
    }
    all()
    {
        return this.items;
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Stores/ValueStore.jsx